import React, { useEffect, useState } from "react";
import { Sparkles, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/api";

const STATUS_COLOR = { done: "#10B981", running: "#F59E0B", failed: "#E63946" };

export default function WeeklyArticleAdmin() {
  const [runs, setRuns] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/weekly-article/runs").then((r) => setRuns(r.data));
  useEffect(() => { load(); const i = setInterval(load, 10000); return () => clearInterval(i); }, []);

  const run = async () => {
    if (!window.confirm("Generare e pubblicare subito un nuovo articolo? Verrà inviata l'email a tutti gli iscritti.")) return;
    setBusy(true);
    try {
      await api.post("/admin/weekly-article/run");
      toast.success("Generazione avviata (2-4 minuti)");
      setTimeout(load, 1500);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="weekly-article-admin">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h2 className="font-heading text-2xl font-extrabold uppercase text-white">Articolo del giovedì</h2>
        <div className="flex gap-2">
          <button onClick={load} data-testid="weekly-refresh-btn" className="p-2 border border-[#272b35] rounded-md text-zinc-300 hover:text-white"><RefreshCw size={16} /></button>
          <button onClick={run} disabled={busy} data-testid="weekly-run-now-btn" className="inline-flex items-center gap-2 px-4 py-2 bg-[#E63946] hover:bg-[#D90429] text-white text-sm font-bold uppercase rounded-md disabled:opacity-50">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />} Genera ora
          </button>
        </div>
      </div>
      <p className="text-sm text-zinc-400 mb-6">Ogni giovedì alle 9:00 (ora italiana) Claude scrive un articolo di curiosità IT + EN (1500-2000 parole), Nano Banana crea la copertina, l'articolo viene pubblicato e tutti gli iscritti ricevono l'avviso.</p>
      <div className="space-y-2">
        {runs.map((r) => (
          <div key={r.key} data-testid={`weekly-run-${r.key}`} className="flex flex-wrap items-center gap-3 bg-[#14161b] border border-[#272b35] rounded-lg px-4 py-3 text-sm">
            <span className="font-mono text-xs text-zinc-500 w-36">{r.key}</span>
            <span className="text-[10px] font-mono uppercase px-2 py-0.5 rounded text-white" style={{ backgroundColor: STATUS_COLOR[r.status] }}>{r.status}</span>
            {r.slug ? <a href={`/article/${r.slug}`} target="_blank" rel="noreferrer" className="text-white hover:text-[#E63946] font-semibold flex-1 min-w-0 truncate">{r.title}</a> : <span className="flex-1 text-zinc-500 truncate">{r.error || "…"}</span>}
            {r.words_it && <span className="font-mono text-xs text-zinc-400">IT {r.words_it} · EN {r.words_en} parole · {r.emails_sent} email</span>}
          </div>
        ))}
        {!runs.length && <p className="text-sm text-zinc-500">Nessuna esecuzione ancora.</p>}
      </div>
    </div>
  );
}
